<template>
  <div
    v-if="modalMessage"
    class="lotteryModal"
  >
    <van-popup
      v-model="isShowPopup"
      :style="{ height: '100%', width: '100%' }"
    >
      <div class="lotteryModal-box">
        <div class="lotteryModal-box__title">{{modalMessage.title}}</div>
        <div class="lotteryModal-box__message" v-html="modalMessage.message"></div>
        <div class="lotteryModal-box__btn" @click="onOK">{{modalMessage.btnText}}</div>
        <div class="lotteryModal-box__close" @click="onClose"></div>
      </div>
      <div class="lotteryModal-bottom"></div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import { Popup } from 'vant';

Vue.use(Popup);

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    modalMessage: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isShowPopup: this.visible
    };
  },
  watch: {
    visible(newValue, oldValue) {
      this.isShowPopup = newValue;
    }
  },
  methods: {
    onOK() {
      this.$emit('update:visible', false);
      this.$emit('onConfirm');
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('onClose');
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../styles/fn.less";
  .lotteryModal {
    width: 100%;
    .lotteryModal-box {
      width: 6.27rem;
      height: 5.58rem;
      z-index: 1;
      position: relative;
      margin: 4.75rem auto auto;
      padding: 0 0.67rem 0 0.7rem;
      text-align: center;
      .bg-image-auto('https://p1.meituan.net/wxapp/a8ba900442af972ca0cbdd6478e173a521169.png');
      .lotteryModal-box__title {
        font-family: 'MF-YuanHeiNoncommercial-Regular';
        font-size: 0.4rem;
        color: #FFFDE5;;
        letter-spacing: 2.3px;
        text-align: center;
        font-weight: 400;
        padding-top: 1.15rem;
      }
      .lotteryModal-box__message {
        font-family: PingFangSC-Regular;
        font-size: 0.26rem;
        color: #FFFDE5;
        letter-spacing: 0;
        text-align: center;
        line-height: 0.4rem;
        font-weight: 400;
        margin-top: 0.16rem;
      }
      .lotteryModal-box__btn {
        width: 4.55rem;
        height: 1.04rem;
        line-height: 1.04rem;
        text-align: center;
        margin: 0.37rem auto auto;
        .bg-image-auto('https://p0.meituan.net/wxapp/a2e1121c06cde505179b03a95fc2894416327.png');font-family: PingFangSC-Semibold;
        font-size: 0.34rem;
        color: #5D1B06;
        text-align: center;
        font-weight: 600;
      }
      .lotteryModal-box__close {
        width: 0.6rem;
        height: 0.6rem;
        position: absolute;
        bottom: -1.2rem;
        left: 0;
        right: 0;
        margin: auto;
        .bg-image-auto('https://p0.meituan.net/wxapp/9e517f84f7347aff588ccde76474fa5f655.png');
      }
    }
    .lotteryModal-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      .block-image(100vw, 48vw, 'https://p0.meituan.net/wxapp/756174624826e34b824116d12b278175250846.png');
    }
    .van-popup {
      background-color: transparent;
    }
    /deep/.van-overlay {
      background-color: rgba(0,0,0,0.8);
    }
    /deep/.highlight {
      text-decoration: underline;
    }
  }
</style>
